// extracted by mini-css-extract-plugin
module.exports = {"root":"GVqi-n","title":"VGwTAw","chip":"RYn-6I","slider":"IWnB4e","controls":"AKvwo7"};